import { AccountAdapter } from "adapters/account";
import { ApiService } from "utils/requestService";

export const getCurrentUser = () => ApiService.get("/me").then((data) => AccountAdapter.toModel(data));

export const redirectToCore = () => {
  window.location.replace(`${process.env.REACT_APP_CORE_HOME}${process.env.REACT_APP_CORE_REDIRECT}`);
};
